import { Features } from 'APP/packages/features/Features';
import Entities from 'STORE';

export function isMarketUrl(url: string): boolean {
  if (!Features.isMarketplaceEnabled()) {
    return false;
  }
  return Entities.marketplace.marketHosts.some((host) => url.indexOf(host) === 0);
}
